import { render, staticRenderFns } from "./HotBook_phone.vue?vue&type=template&id=4185a019&scoped=true"
import script from "./HotBook_phone.vue?vue&type=script&lang=js"
export * from "./HotBook_phone.vue?vue&type=script&lang=js"
import style0 from "./HotBook_phone.vue?vue&type=style&index=0&id=4185a019&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185a019",
  null
  
)

export default component.exports